module.exports = __webpack_public_path__ + "合作4.png?a6f316f540d773c1b94011bdc4507f9d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作4.png
// module id = 646
// module chunks = 0